import IconButton from '@mui/material/IconButton';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CardFiles from '../../../../../components/CockpitCards/CardFiles';


export default function CRAI(data) {


return (
<>
<CardFiles

headline = "CRAM Index" 
subtext = "Here you can download the CRAM index file. This file contains the index information for efficient CRAM file reading."

    content_1 = {<>                           
            Sample: <br />
            Date: <br />
            Sequencer: <br />
            File Size: <br />
            Description: 
         </>} 

content_2 = {<>                

            {data.data[0]} <br />
            {data.data[1]} <br />
            {data.data[2]} <br />
            ~ 1 MB <br />
            Index <br />HRE_HG38 <br />
            </>} 

action = {
        <IconButton href = {data.data[3]} sx={{ color: 'success.light' }} >
            <CloudDownloadIcon sx={{fontSize: '2.5rem',}} /> 
        </IconButton> 
}
  

/>    
</>

)};
